export default "__VITE_ASSET__0KHZD7n3__"